module.exports = __webpack_public_path__ + "image/copilot-bot.a8917828.png";